<template lang="pug">
  div
    div(v-if="mails.length || mailLoading")
      rc-table(
        @recall="getMail"
        @tableSearchAction="previewMail"
        :totalItems="totalMails"
        :items="mails"
        :headers="headers"
        :loading="mailLoading"
        :displayFilters="false"
        :displaySortable="false"
        :deleteAction="false"
      )
      v-dialog(v-model="mailPreviewOpen" width="50%" persistent)
        v-card
          v-btn.mr-2(style="margin-top: 42px;" fab dark small absolute top right color="primary")
            v-icon(medium @click="mailPreviewOpen = false") close
          v-card-text.mail-preview-wrapper
            div(v-html="previewBody")
    v-layout.justify-center.pt-5.px-5.font-italic.text-xs-center.subheading.grey--text.text--darken-2(v-else)
      |Aucun mail n'a encore été reçu
</template>

<script>
import RcTable from '@/components/RcTable/RcTable.vue';
import axios from 'axios';

export default {
  components: {
    RcTable,
  },
  data() {
    return {
      mails: [],
      totalMails: 0,
      mailLoading: true,
      mailPreviewOpen: false,
      previewBody: "",
      headers: [
        {
          label: 'ID',
          type: 'id',
          sortable: false,
          column: 'id',
          width: '0px',
        },
        {
          label: 'Envoyé le',
          type: 'dateTime',
          sortable: false,
          column: 'date_sent',
          width: '15%',
        },
        {
          label: 'Sujet',
          sortable: false,
          column: 'subject',
          width: '30%',
        },
        {
          label: 'Envoyé par',
          sortable: false,
          column: 'sender_partner_name',
          width: '12%',
        },
        {
          label: 'Envoyé à',
          sortable: false,
          column: 'to_email',
          width: '23%',
        },
        {
          label: 'État',
          type: 'mailState',
          sortable: false,
          width: '20%',
        },
      ],
    };
  },
  mounted() {
    this.getMail();
  },
  methods: {
    getMail({start = 0, size = 100} = {}) {
      this.mailLoading = true;
      const contactId = this.$route.params.contactId;
      axios.create({ headers: { 'Cache-Control' : 'no-cache' } })
      .get(`/v2/erp/contact/${contactId}/mail/history?start=${start}&size=${size}`).then((mailResponse) => {
        this.mails = mailResponse.data.values;
        this.totalMails = mailResponse.data.count;
        this.mailLoading = false;
      });
    },
    previewMail(item) {
      this.previewBody = item.body;
      this.mailPreviewOpen = true;
    },
  },
}
</script>

<style lang="scss">
  .mail-preview-wrapper {
    pointer-events: none;
    h1 {
      margin: 20px 0 20px 0;
    }
  }
</style>
